import { render } from "./CodeForm.vue?vue&type=template&id=4f7e7284&scoped=true&ts=true"
import script from "./CodeForm.vue?vue&type=script&lang=ts"
export * from "./CodeForm.vue?vue&type=script&lang=ts"

import "./CodeForm.vue?vue&type=style&index=0&id=4f7e7284&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f7e7284"]])

export default __exports__